import { action } from 'typesafe-actions';
import { ActionCenterPrefill } from './action-center-prefill';
import { CLEAR_ACTION_CENTER_PREFILL, SET_ACTION_CENTER_PREFILL } from './constants';

export const setActionCenterPrefill = (payload: ActionCenterPrefill) =>
  action(SET_ACTION_CENTER_PREFILL, payload);

export const clearActionCenterPrefill = () => action(CLEAR_ACTION_CENTER_PREFILL);
